import React,{Component} from 'react'

import LaunchIcon from 'material-ui-icons/Launch'

import {
  LightGray,
} from '../helper/consts'

const style = {
  container:{
    display:'flex',
    whiteSpace: 'pre',
    flexWrap: 'wrap',
  },
  link:{
    display: 'flex',
    alignItems: 'center',
  },
  launchIcon:{
    color:LightGray,
    transition:'color 0.3s ease',
    marginLeft:'5px',
  }
}

export default class JobCardHeaderTitle extends Component{
  render(){
    const {job} = this.props;
    return(
      <span style={style.container}>
        {job.title}{(job.title && job.title.length!==0)?' @ ':''}{job.companyURI?<a style={style.link} target="_blank" rel='noopener' href={job.companyURI}>{job.company}{<LaunchIcon className='blackOnHover' style={style.launchIcon} />}</a>:job.company}
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/JobCardHeaderTitle.js